import classNames from 'classnames';
import { useTranslation } from 'next-i18next';
import React from 'react';

import { NextImage, Typography } from '@/shared/components/atoms';
import { IDetailsPageHeaderProps } from '@/shared/components/molecules/DetailsPageHeader/DetailsPageHeader';

import Arrow from '~/images/shared/arrow.svg';

const DetailsPageHeader: React.FC<IDetailsPageHeaderProps> = (props) => {
  const { t, i18n } = useTranslation();

  const statusStyles = {
    yellow: {
      text: 'text-tertiary-20',
      bg: 'bg-neutralVariant-96',
    },
    green: {
      text: 'text-green-300',
      bg: 'bg-secondary-90',
    },
    red: {
      text: 'text-error-20',
      bg: 'bg-error-90',
    },
    blue: {
      text: 'text-primary-400',
      bg: 'bg-outline-default',
    },
    grey: {
      text: 'text-surface-10',
      bg: 'bg-neutralVariant-90',
    },
  };

  const statusTypography = (
    <Typography
      weight='bold'
      variant='body1'
      className={classNames(
        'rounded-xl py-4 px-16',
        statusStyles[props.status.color].text,
        statusStyles[props.status.color].bg
      )}
    >
      {props.status.label}
    </Typography>
  );

  return (
    <div className='flex items-center justify-between rounded-2xl bg-white p-24'>
      <div className='flex items-center gap-8'>
        <span className='flex h-56 w-56 items-center justify-center rounded-full bg-primary-95'>
          {typeof props.icon === 'string' ? (
            <NextImage
              src={props.icon}
              width={props?.imageProps?.width ?? 30}
              height={props?.imageProps?.height ?? 30}
              alt={props.title}
            />
          ) : (
            props.icon
          )}
        </span>
        <div>
          <div className='mb-8 flex items-center gap-8'>
            <Typography variant='h2' weight='bold'>
              {t(props.title)}
            </Typography>
            {props.statusPlacement === 'left' && statusTypography}
          </div>
          <Typography
            className='flex items-center gap-9 text-surface-10'
            variant='subtitle2'
            weight='semiBold'
          >
            {props.timeline.map((item, idx) => (
              <React.Fragment key={`${item.date}${item.title}${idx}`}>
                {`${t(item.title)} ${item.date}`}
                <span
                  className={classNames(
                    i18n.dir() === 'ltr' && '-scale-x-100 transform'
                  )}
                >
                  {idx < props.timeline.length - 1 && <Arrow width='5px' />}
                </span>
              </React.Fragment>
            ))}
          </Typography>
        </div>
      </div>
      {props.statusPlacement === 'right' && statusTypography}
      {props?.children}
    </div>
  );
};

DetailsPageHeader.defaultProps = {
  statusPlacement: 'left',
};

export default DetailsPageHeader;
